import { ErrorMessageEnum } from '@rehau/shared/enums';
import { StringValidation } from '@rehau/shared/forms/validations';
import { NewPasswordRegexp } from '@rehau/shared/regexps';

export class NewPasswordValidation extends StringValidation {
  constructor() {
    super(null, null, [{ pattern: NewPasswordRegexp, message: ErrorMessageEnum.password_requirements_not_provided }]);
  }
}
